import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder for the reservation itinerary — a couple of flight segment cards. */
export function FullReservationItinerarySkeleton() {
  return (
    <div className="space-y-2 py-2">
      {["seg-1", "seg-2"].map((id, index) => (
        <div key={id}>
          <div className="rounded-lg border border-gray-300 bg-white p-4 shadow-sm">
            <div className="flex items-start justify-between gap-4">
              <div className="flex gap-x-4">
                <Skeleton className="h-10 w-10 rounded-full" />
                <div className="space-y-2">
                  <Skeleton className="h-4 w-64" />
                  <Skeleton className="h-3 w-44" />
                  <Skeleton className="h-3 w-40" />
                </div>
              </div>
              <div className="hidden sm:flex sm:flex-col sm:items-end sm:gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-16" />
              </div>
            </div>
          </div>
          {index === 0 ? (
            <div className="flex justify-center py-2">
              <Skeleton className="h-8 w-28 rounded-full" />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
